module.exports = __webpack_public_path__ + "img/1.21209a42.png";